/**
 * Sort the given array.
 *
 * @param array
 * @param asc
 * @param caseSensitive
 * @param mapCallback - If the callback is specified, each value will be passed to the callback, and the value returned by
 * the callback will be used instead. A little like combining Array.prototype.map with sorting.
 */
export function array_sort(array, asc = true, caseSensitive = true, mapCallback = null) {
    const direction = asc
        ? 1
        : -1;

    return array.sort((a, b) => {
        let aValue = a,
            bValue = b;

        if (mapCallback) {
            aValue = mapCallback(aValue);
            bValue = mapCallback(bValue);
        }

        // When you compare strings in JS, their characters' unicode indexes are used to compare their value. So
        // converting to upper case implicitly makes the sorting case insensitive.
        if (! caseSensitive) {
            // Fast convert to string, and make uppercase
            aValue = ('' + aValue).toUpperCase();
            bValue = ('' + bValue).toUpperCase();
        }

        if (aValue < bValue) {
            return -direction;
        }

        if (aValue > bValue) {
            return direction;
        }

        return 0;
    });
}

export function array_sort_asc(array, caseSensitive = true, mapCallback = null) {
    return array_sort(array, true, caseSensitive, mapCallback);
}

export function array_sort_desc(array, caseSensitive = true, mapCallback = null) {
    return array_sort(array, false, caseSensitive, mapCallback);
}

export function array_shuffle(array) {
    for (let i = array.length - 1; i > 0; --i) {
        const j = Math.floor(Math.random() * (i + 1));

        [array[i], array[j]] = [array[j], array[i]];
    }

    return array;
}